import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_5e1660a2 from '../styles/Divider.module.less.js';

/**
 * @description A divider line separates different content
 *
 * @component
 * @example
 * ```jsx
 * <Divider />
 * ```
 */
const Divider = React.forwardRef((props, ref) => {
    const { size, color = 'dark', type = 'solid', className, ...restProps } = props;
    const cx = useStyles(modules_5e1660a2);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
        [`type-${type}`]: type,
        [`color-${color}`]: true,
    });
    return React.createElement("div", { ref: ref, "data-qa": "Divider", className: classNames, ...restProps });
});
Divider.displayName = 'Divider';

export { Divider };
//# sourceMappingURL=Divider.js.map
